module.exports = __webpack_public_path__ + "static/img/usuario-sin-foto.0d09cb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/usuario-sin-foto.png
// module id = PnpA
// module chunks = 2